import React, { useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { RenderButton, LinkButton } from '~button';
import Container from './Container';
import Options from './Options';
import StyleOptions from './StyleOptions';
import Details from './Details';
import PriceTag from './PriceTag';
import CallToActionContainer from './CallToActionContainer';
import CallToAction from './CallToAction';
import commercePropTypes from '../../prop-types/commercePropTypes';

var ProductCheckout = function ProductCheckout(_ref) {
  var intl = _ref.intl,
      price = _ref.price,
      currency = _ref.currency,
      discount = _ref.discount,
      ctaPath = _ref.ctaPath,
      onClickCta = _ref.onClickCta,
      isExternalCta = _ref.isExternalCta,
      index = _ref.index,
      availableStyles = _ref.availableStyles,
      onProductChange = _ref.onProductChange,
      isSubmitting = _ref.isSubmitting,
      isRow = _ref.isRow,
      productSlug = _ref.productSlug,
      showStyleOptionsLabel = _ref.showStyleOptionsLabel;

  var _useState = useState(),
      currVariantId = _useState[0],
      setCurrVariantId = _useState[1];

  var handleOnProductChange = function handleOnProductChange(e) {
    setCurrVariantId(e);
    onProductChange(e);
  };

  return /*#__PURE__*/React.createElement(Container, {
    isRow: isRow
  }, /*#__PURE__*/React.createElement(Options, {
    isRow: isRow
  }, /*#__PURE__*/React.createElement(StyleOptions, {
    options: availableStyles,
    index: index,
    onOptionChange: function onOptionChange(e) {
      return handleOnProductChange(e);
    },
    disabled: isSubmitting,
    showLabel: showStyleOptionsLabel
  })), /*#__PURE__*/React.createElement(Details, {
    isRow: isRow
  }, /*#__PURE__*/React.createElement(PriceTag, {
    price: price,
    discount: discount,
    currency: currency
  }), /*#__PURE__*/React.createElement(CallToActionContainer, null, /*#__PURE__*/React.createElement(CallToAction, null, /*#__PURE__*/React.createElement(RenderButton, {
    skin: "secondary",
    size: "lg",
    path: ctaPath,
    label: intl.formatMessage({
      id: 'commerce.orderNow.label'
    }),
    onClick: onClickCta,
    isExternal: isExternalCta,
    type: "submit",
    disabled: isSubmitting,
    loading: isSubmitting,
    loadingMessage: intl.formatMessage({
      id: 'commerce.orderNow.loading.label'
    })
  })), productSlug && /*#__PURE__*/React.createElement(CallToAction, null, /*#__PURE__*/React.createElement(LinkButton, {
    btnType: "link",
    skin: "muted",
    size: "lg",
    to: productSlug,
    state: {
      currVariantId: currVariantId
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "commerce.viewMore.label"
  }))))));
};

ProductCheckout.defaultProps = {
  price: undefined,
  discount: undefined,
  ctaPath: null,
  onClickCta: null,
  isExternalCta: false,
  onProductChange: null,
  isSubmitting: false,
  currency: undefined,
  isRow: false,
  productSlug: undefined,
  showStyleOptionsLabel: undefined
};
export default injectIntl(ProductCheckout);